import * as CommonConstants from "utilities/CommonConstants";
import * as DbValueConstants from "utilities/DbValueConstants";

export class BookingUtil {
    /**
     * 予約種別IDに紐づく名称を取得
     * @param bookingTypeId
     * @return 予約種別名
     */
    static getNameByBookingType = (bookingTypeId: number | undefined) => {
        let value = ``;
        switch (bookingTypeId) {
            case DbValueConstants.BOOKING_TYPE_ID_TAKEOUT:
                value = CommonConstants.BOOKING_TYPE_NAME_TAKEOUT;
                break;
            case DbValueConstants.BOOKING_TYPE_ID_POMPOUT1:
                value = CommonConstants.BOOKING_TYPE_NAME_POMPOUT1;
                break;
            case DbValueConstants.BOOKING_TYPE_ID_POMPOUT2:
                value = CommonConstants.BOOKING_TYPE_NAME_POMPOUT2;
                break;
            default:
                break;
        }
        return value;
    };

    /**
     * 予約種別ごとのカラーを取得
     * @param bookingTypeId 予約種別ID
     * @return カラー
     */
    static getColorByBookingType = (bookingTypeId: number | undefined): string => {
        let value = ``;
        switch (bookingTypeId) {
            case DbValueConstants.BOOKING_TYPE_ID_TAKEOUT:
                value = CommonConstants.BOOKING_TYPE_COLOR_TAKEOUT;
                break;
            case DbValueConstants.BOOKING_TYPE_ID_POMPOUT1:
                value = CommonConstants.BOOKING_TYPE_COLOR_POMPOUT1;
                break;
            case DbValueConstants.BOOKING_TYPE_ID_POMPOUT2:
                value = CommonConstants.BOOKING_TYPE_COLOR_POMPOUT2;
                break;
            default:
                break;
        }
        return value;
    };

    /**
     * 予約種別ごとのclassNameを取得
     * @param bookingTypeId 予約種別ID
     * @return className
     */
    static getClassNameByBookingType = (bookingTypeId: number): string => {
        let value = ``;
        switch (bookingTypeId) {
            case DbValueConstants.BOOKING_TYPE_ID_TAKEOUT:
                value = CommonConstants.BOOKING_TYPE_CLASS_TAKEOUT;
                break;
            case DbValueConstants.BOOKING_TYPE_ID_POMPOUT1:
                value = CommonConstants.BOOKING_TYPE_CLASS_POMPOUT1;
                break;
            case DbValueConstants.BOOKING_TYPE_ID_POMPOUT2:
                value = CommonConstants.BOOKING_TYPE_CLASS_POMPOUT2;
                break;
            default:
                break;
        }
        return value;
    };
}
